import config from '../config.json';

import '../styles/MapViewer.css';

const MapViewer = ({ id }) => {
    return (
        <div id='MapViewer'>
            <img src={config.backendUrl + '/maps/render/' + id} alt={id}/>
        </div>
    );
}

export default MapViewer;
